var APP_ACTIONS = {
  setAdminDetails: 'SET_ADMIN_DETAILS',
  setProductList: 'SET_PRODUCT_LIST',
  setProductServiceInfo: 'SET_PRODUCT_SERVICE_INFO',
  viewAlertInitiated: 'VIEW_ALERT_INITIATED',
  viewAlertSucceeded: 'VIEW_ALERT_SUCCEEDED',
  viewAlertFailed: 'VIEW_ALERT_FAILED',
  setApiConfig: 'SET_API_CONFIG'
};
export default APP_ACTIONS;